import Product from './Product';
import Entities from '@gqlapp/core-common/Entities';

export default class Products extends Entities {
  constructor(props?:any) {
    super(props);
    this.interface = Product;
  }
}
